import React from 'react';
import { fetchErrorData } from '../../../modules/API/API';
// 청크 로드 실패(배포 직후 구버전 탭 재진입 등) 판별 — webpack(react-scripts 5)은
// name==='ChunkLoadError', 메시지 'Loading chunk N failed' / 'Loading CSS chunk N failed'.
// dynamic import 직접 실패 문구도 방어적으로 포함한다.
const isChunkLoadError = (error) => {
    if (!error)
        return false;
    if (error.name === 'ChunkLoadError')
        return true;
    const message = String(error.message || '');
    return /loading (css )?chunk/i.test(message) || /dynamically imported module/i.test(message);
};
// 루트 Suspense 에는 에러 경계가 없어 lazy 청크 로드 실패 시 로딩 화면에, 렌더 크래시 시
// 흰 화면에 영구 고착되던 문제를 앱 최상위에서 흡수한다(Suspense 는 pending 만 잡고
// 에러는 못 잡음). 정상 경로에서는 children 을 그대로 반환하므로 렌더에 어떤 개입도 없다.
// ★크래시 자동 새로고침 금지 — 배포 직후 다수 탭 동시 reload 폭풍 방지, 수동 버튼만 제공.
class AppErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false, isChunkError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, isChunkError: isChunkLoadError(error) };
    }
    componentDidCatch(error, errorInfo) {
        console.error('앱 렌더 크래시:', error, errorInfo?.componentStack);
        // 진단 로그 fire-and-forget — fetchErrorData 는 5초 상한·무reject 이지만,
        // 크래시 경로에서는 동기 예외조차 fallback 렌더를 방해하면 안 되므로 한 번 더 방어.
        try {
            fetchErrorData({
                message: 'APP_RENDER_CRASH',
                data: {
                    isChunkError: isChunkLoadError(error),
                    error: String(error?.message || error),
                    stack: String(error?.stack || '').slice(0, 2000),
                    componentStack: String(errorInfo?.componentStack || '').slice(0, 2000),
                    href: window.location.href,
                },
            });
        }
        catch (e) { /* 보고 실패는 무시 */ }
    }
    render() {
        if (this.state.hasError) {
            // ★외부 css 의존 금지(인라인만) — css 청크 로드 실패 상황에서도 렌더 보장
            return (React.createElement("div", { style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: '#1b1b1b',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000,
                } },
                React.createElement("p", { style: { color: '#fff', fontSize: 15, margin: '0 0 8px', textAlign: 'center', padding: '0 16px' } }, "\uD654\uBA74\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4."),
                this.state.isChunkError && (React.createElement("p", { style: { color: '#aaa', fontSize: 13, margin: '0 0 12px', textAlign: 'center', padding: '0 16px' } }, "\uC0C8 \uBC84\uC804\uC774 \uBC30\uD3EC\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.")),
                React.createElement("button", { onClick: () => window.location.reload(), style: {
                        padding: '10px 24px',
                        marginTop: 12,
                        background: '#4a7dff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        fontSize: 14,
                        cursor: 'pointer',
                    } }, "\uC0C8\uB85C\uACE0\uCE68")));
        }
        return this.props.children;
    }
}
export default AppErrorBoundary;
